module.exports = __webpack_public_path__ + "img/mb_product_bg_small.e450353.webp";